export const PARTIAL_GAME_DOMAIN = {
  filters: {
    top: 'top',
    featured: 'featured',
    slider: 'slider',
    fixtures: 'fixtures',
    results: 'results',
    recent: 'current',
    myScores: 'myscores',
    predictions: 'predictions',
    allScores: 'allscores',
    suggestions: 'suggestions',
    contextualPredictions: 'predictions/contextual'
  },

  contexts: {
    allScores: 1,
    myScores: 2,
    competitionScoresScreen: 3,
    competitorScores: 4
  }
}
